import { CategoryEnum } from '../enums/category';
import { LifeStyleSubCategoryEnum } from '../enums/sub-category';

export const getCategoryTitle = (c: CategoryEnum, sc?: string): string => {
    switch (c) {
        case CategoryEnum.residentialForRent:
            return 'Residential, For Rent';
        case CategoryEnum.residentialForSale:
            return 'Residential, For Sale';
        case CategoryEnum.lifeStyle:
            return `Residential, For Sale, Lifestyle ${sc === LifeStyleSubCategoryEnum.dwelling
                ? 'dwelling'
                : 'bare land'}`;
        case CategoryEnum.newHomesHouseAndLand:
            return 'New homes, House & land';
        case CategoryEnum.newHomesNewApartment:
            return 'New homes, New apartment';
        case CategoryEnum.newHomesNewHouse:
            return 'New homes, New house';
        case CategoryEnum.newHomesNewTownhouseAndTerraced:
            return 'New homes, New townhouse & terraced';
        case CategoryEnum.sectionsForSale:
            return 'Residential, For Sale, Section';
        case CategoryEnum.rural:
            return 'Residential, For Sale, Rural';
        default:
            return '';
    }
};
